import React from "react";
import { client } from "../services/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import ContentWrapper from "../components/ContentWrapper";
import Activities from "../components/Activities";
import AccountMenu from "../components/AccountMenu";
import MenuItem from "../components/MenuItem";
import { useNavigate } from "react-router-dom";
import ContactUs from "../images/contact-us.svg";
import CustomerSupport from "../images/customer-support.svg";
import Privacy from "../images/privacy-tip-outline.svg";
import ReactGA from "react-ga4";

function Home() {
  const navigate = useNavigate();

  const handleNewRequest = () => {
    client.logAction('newRequestStarted');
    ReactGA.event({
      category: "User",
      action: "New_Request_Started",
      label: "User started new request",
      value: 1,
    });

    navigate("/new-request");
  }

  return (
    <div className="home">
      <Header />
      <div className="main-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="main-content-primary" style={{ padding: '36px 24px' }}>
            <Activities />
          </div>
          <div className="main-content-sidebar">
            <ContentWrapper>
              <AccountMenu />
            </ContentWrapper>
            <button className="new-request-btn" onClick={handleNewRequest}>
              + New Request
            </button>
            <ContentWrapper>
              <MenuItem icon={ContactUs} name="Contact Us" onClick={() => window.open("mailto:info@titan4.it", "_blank")} />
              <MenuItem icon={CustomerSupport} name="Service Desk" onClick={() => window.open("mailto:info@titan4.it", "_blank")} />
              <MenuItem icon={Privacy} name="Privacy Policy" onClick={() => navigate(`/privacy-policy`)} />
            </ContentWrapper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
